module.exports = __webpack_public_path__ + "static/media/evaporative-system-monitor.6bda35bf.svg";